module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: [
      'btn',
      'btn--' + (_vm.button || 'secondary'),
      'btn--' + (_vm.size || 'm'),
      {
        'btn--idle': (!_vm.hover && !_vm.isHover && !_vm.active && !_vm.isActive),
        'btn--hover': (_vm.hover || _vm.isHover || _vm.active || _vm.isActive) && !_vm.disabled,
        'btn--active': (_vm.active || _vm.isActive) && !_vm.disabled && !_vm.hover,
        'btn--disabled': _vm.disabled,
      }
    ],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "mouseover": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.onMouseDown($event)
      },
      "click": _vm.onClick
    },
    nativeOn: {
      "mouseover": function($event) {
        return _vm.onMouseEnter($event)
      },
      "mouseleave": function($event) {
        return _vm.onMouseLeave($event)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.onMouseDown($event)
      }
    }
  }, 'component', _vm.linkProps, false), [_c('span', {
    staticClass: "btn__inner"
  }, [_c('span', {
    staticClass: "btn__content"
  }, [_c('span', {
    staticClass: "btn__label"
  }, [(!_vm.label) ? _vm._t("default") : _vm._e(), _vm._v(_vm._s(_vm.label || "") + "\n      ")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7298420e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Button.vue
// module id = 29
// module chunks = 1